import {
  type ComponentType as ReactComponentType,
  forwardRef,
  type ForwardRefExoticComponent,
} from 'react';

export type ContainerComponentProps<Props> = Props extends Props
  ? Omit<Props, 'dangerouslyOverrideClassName'> & { className?: string }
  : never;

export function withClassNameHoc<
  P extends {
    dangerouslyOverrideClassName?: { __className?: string };
  },
>(Component: ReactComponentType<P> | ForwardRefExoticComponent<P>) {
  const hoc = forwardRef<unknown, ContainerComponentProps<P>>((props, ref) => {
    const { className, ...remaining } = props;

    const rest = {
      ...remaining,
      ...(className && {
        dangerouslyOverrideClassName: { __className: className },
      }),
    } as unknown as P;

    return <Component ref={ref} {...rest} />;
  });

  hoc.displayName = `withClassNameHoc(${Component?.displayName || Component?.name || 'Component'})`;

  return hoc;
}
